import { h, render } from 'preact';
import { useEffect } from 'preact/hooks';
import styles from './CelebrationModal.styles.css';
import ShadowWrapper from '../ShadowWrapper/ShadowWrapper.jsx';

const CelebrationModal = ({
  isActive,
  onModalClose,
  youtubeid = 'xEOiGs2y4_o',
  userImgSource,
  userName,
  fulfilledDate
}) => {
  useEffect(() => {
    const fontsLink = document.querySelector('link[href="https://use.typekit.net/xid0xno.css"]');

    if (!fontsLink) {
      const link = document.createElement('link');
      link.href = 'https://use.typekit.net/xid0xno.css';
      link.rel = 'stylesheet';
      document.head.appendChild(link);

      return () => {
        document.head.removeChild(link);
      };
    }
  }, []);

  useEffect(() => {
    if (isActive) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isActive]);

  const closeModal = () => {
    document.body.style.overflow = 'auto';
    window.dispatchEvent(new Event('celebration-modal-closed'));
    if (typeof onModalClose === 'function') onModalClose();
  };

  const nameParts = userName.split(' ');
  const firstName = nameParts[0];
  const shortName = `${firstName} ${nameParts[1][0]}.`;

  return (
    <ShadowWrapper styles={styles}>
      <div
        className={`modal-celebration ${isActive ? 'is-active' : ''}`}
        tabIndex="-1"
        onClick={closeModal}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          webkit-playsinline="true"
          disablePictureInPicture
          disableRemotePlayback
          width="100%"
          height="100%"
          className="background-video"
          style={{ pointerEvents: 'none' }}
        >
          <source
            src="https://videos.ctfassets.net/y3a9myzsdjan/1ycnFnTWMFUiUPpzXmY1SO/7cb07c3bd26f5f7dcd5e703ad0f5688f/fulfill-modal-background.mp4"
            type="video/mp4"
          />
        </video>
        <div className="modal-content" onClick={(event) => event.stopPropagation()}>
          <div className="modal-header">
            <button type="button" className="modal-close" onClick={closeModal}>
              <span>Close</span>
              <img
                src="https://images.ctfassets.net/y3a9myzsdjan/2LfLqJG3kk80XgB1F8D6nH/5c1c20cc8ad3bb89273293e5ee6d9af6/modal-close-button.png"
                alt=""
              />
            </button>
          </div>
          <div className="modal-body">
            <div className="modal-body-content">
              <div className="did-it-box mobile">
                YOU DID IT, <br />
                {firstName}!
              </div>
              <div className="youtube-video">
                {isActive && (
                  <iframe
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${youtubeid}`}
                    frameborder="0"
                    allowfullscreen
                  />
                )}
              </div>
              <div className="info-box">
                <div className="did-it-box desktop">
                  YOU DID IT, <br />
                  {firstName}!
                </div>
                <div className="user-info-container">
                  <div className="img-date-container">
                    <div className="user-img-container">
                      {userImgSource && <img className="user-img" src={userImgSource} alt="" />}
                      <span>{shortName}</span>
                    </div>
                    {fulfilledDate && (
                      <div className="goal-date">You met your goal on {fulfilledDate}</div>
                    )}
                  </div>
                  <p className="goal-text-info">
                    Mission Accomplished! You leaned into being pushed and did the hard thing of
                    fulfilling your commitment. Because of faithful and generous people like you,
                    Earth will look more like Heaven as we 10X our impact, expand the territories
                    God has given us, and seek to bring an Awakening to our land.
                  </p>
                  <img
                    className="pastor-sign"
                    src="https://crds-media.imgix.net/y3a9myzsdjan/3kbEVvLLlC7eCy8ouC8DBE/3e857c576570b80c321d8f644cb4bca4/kyle-signature.png"
                    alt=""
                  />
                </div>
                <div className="pastor-name">Kyle Ranson, Lead Pastor</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ShadowWrapper>
  );
};

// Function to mock the modal
window.openCelebrationModal = (setIsShown, youtubeid, userImgSource, userName, fulfilledDate) => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  setIsShown(false);

  const closeModal = () => {
    render(null, container);
    document.body.removeChild(container);
    setIsShown(true);
  };

  render(
    <CelebrationModal
      isActive
      onModalClose={closeModal}
      youtubeid={youtubeid}
      userImgSource={userImgSource}
      userName={userName}
      fulfilledDate={fulfilledDate}
    />,
    container
  );
};

export default CelebrationModal;
